export default __webpack_public_path__ + "static/media/logoutGray.425fcd46.svg";